import { Button, Col, Skeleton, useTheme } from "@commonlibs";
import clsx from "clsx";
import QR from "ui/common/components/display/QR/QR";
import { QrCard } from "./ReceiveTab.styles";
import { useTranslate } from "ui/locale";
import useGetWalletAddress from "ui/wallet/query/useGetWalletAddress";
import ShareButton from "ui/common/components/input/ShareButton/ShareButton";
import { QRCodeDto } from "ui/transactions/utils/QRCodeDto";
import { useRef } from "react";

export interface ReceiveTabProps {
    className?: string;
    style?: React.CSSProperties;
}

function ReceiveTab({ className, ...rest }: ReceiveTabProps) {
    const { spacing } = useTheme();
    const translate = useTranslate();
    const { data: walletAddress } = useGetWalletAddress();
    const shareUrl = QRCodeDto.generateShareUrl(walletAddress);
    const qrRef = useRef<HTMLDivElement>(null);

    function onDownloadQR() {
        const qrSvg = qrRef.current?.querySelector("svg");
        if(!qrSvg) return;
        QRCodeDto.downloadQR(qrSvg);
    }

    return (
        <Col gap={spacing["6"]} className={clsx("receive-tab", className)} justifyContent="space-between" css={{ flex: 1 }} {...rest}>
            <QrCard>
                <Skeleton loading={!walletAddress} width="100%">
                    <QR qrRef={qrRef} id="reqct-qr-code" value={shareUrl} />
                </Skeleton>
            </QrCard>
            <Col gap={spacing["4"]}>
                <ShareButton variant="primary" shareData={{ title: translate("myAccountNutresa"), text: shareUrl, url: shareUrl }}>
                    {translate("shareQrCode")}
                </ShareButton>
                <Button variant="secondary" onClick={onDownloadQR}>
                    {translate("saveQRAsImage")}
                </Button>
            </Col>
        </Col>
    );
}

export default ReceiveTab;
